import {
  NOT_FOUND
} from 'redux-first-router'

export const CallbackReducer = (state = null, action = {}) => {
  switch (action.type) {
    case NOT_FOUND:
      return null
    case 'CALLBACK':
      return {
        ...state,
        authCode: action.meta.query.hasOwnProperty('code') ? action.meta.query.code : null,
        error: action.meta.query.hasOwnProperty('error') ? action.meta.query.error : null
      };
    default:
      return state
  }
}

export default CallbackReducer;


// WEBPACK FOOTER //
// ./src/modules/callback/CallbackState.js